uniform float time;
uniform sampler2D tDiffuse;
uniform vec2 uResolution;

varying vec2 vUv;

float random(vec2 p) {
    vec3 p3 = fract(vec3(p.xyx) * 0.1031);
    p3 += dot(p3, p3.yzx + 33.33);
    return fract((p3.x + p3.y) * p3.z);
}

void main() {
    vec2 uv = vUv;
    
    /* ==========================================
       ORIGINAL CRT SHADER CODE (COMMENTED OUT)
       ==========================================
    
    // 1. Chromatic Aberration (Stronger Horizontal Shift)
    float dist = distance(uv, vec2(0.5));
    float strength = pow(dist, 2.0) * 0.01;
    
    float r = texture2D(tDiffuse, uv + vec2(strength, 0.0)).r;
    float g = texture2D(tDiffuse, uv).g;
    float b = texture2D(tDiffuse, uv - vec2(strength, 0.0)).b;
    vec3 color = vec3(r, g, b);

    // 2. Vertical RGB Phosphor Mask (Aperture Grille)
    float maskScale = 700.0; 
    float maskX = mod(uv.x * maskScale, 1.0);
    vec3 mask = vec3(0.4);
    
    if (maskX < 0.33) mask.r = 1.8;
    else if (maskX < 0.66) mask.g = 1.8;
    else mask.b = 1.8;
    
    color *= mask;

    // 3. Heavy Scanlines
    float scanlineValue = sin(uv.y * 1500.0) * 0.15 + 0.85;
    color *= scanlineValue;

    // 4. Subtle Noise / Grain
    float noise = 0.95 + 0.5 * random(uv * time);
    // color *= noise;

    // 5. Brightness & Contrast Boost
    color = pow(color, vec3(0.9));
    color *= 1.0;
    ========================================== */

    // ==========================================
    // NEW BALATRO-STYLE CRT SHADER CODE
    // ==========================================
    
    // 1. Chromatic Aberration (stronger toward edges, like a CRT lens)
    vec2 dir = uv - 0.5;
    float aberration = pow(length(dir), 2.0) * 0.025;
    float r = texture2D(tDiffuse, uv + dir * aberration).r;
    float g = texture2D(tDiffuse, uv).g;
    float b = texture2D(tDiffuse, uv - dir * aberration).b;
    vec3 color = vec3(r, g, b);

    // 2. Alternating Horizontal Scanlines (one darker, one lighter)
    // We use the vertical screen resolution to ensure scanlines align nicely with the viewport.
    // Scaling by 1.5 (similar to Balatro's frequency) creates thin, distinct alternating lines.
    // Using sine wave to oscillate between lighter (multiplier > 1.0) and darker (multiplier < 1.0) states.
    float scanline = sin(uv.y * uResolution.y * 1.5) * 0.15;
    float scanlineValue = 1.0 - scanline; // Alternates between 0.85 (darker) and 1.15 (lighter)
    color *= scanlineValue;

    // 3. Noise / Grain (mod keeps numbers small to avoid precision issues while animating every frame)
    float noise = 0.95 + 0.5 * random(gl_FragCoord.xy + mod(time, 100.0) * 13.7);

    // 4. Subtle Vignette
    float dist = distance(uv, vec2(0.5));
    float vignette = 1.0 - smoothstep(0.35, 0.75, dist) * 1.02;
    color *= vignette;
    color *= noise;

    // 5. Subtle exposure correction to preserve overall brightness
    color = pow(color, vec3(0.95)); // Soft gamma adjustment

    gl_FragColor = vec4(color, 1.0);
}